module.exports = __webpack_public_path__ + "img/first-comparison.c6d1fb6e.gif";